import Breakpoint from 'src/Components/Breakpoint'

// keep in sync with HomeownerDashboard.module.scss
export const HomeownerDashboard = Breakpoint(899)
